import toast from "react-hot-toast";
import { create } from "zustand";
import { find, generateCode, getAll } from "../services/service";
export const useStoreApp = create((set) => ({
  loading: false,
  codeLoading: false,
  data: [],
  liste: [],
  superviseur: [],
  listAbonnement: [],
  listSouscriptions: [],
  code: null,
  getListSuperviseur: async (url) => {
    set({
      loading: true,
      superviseur: [],
    });
    try {
      const superviseurs = await find(url);
      set({
        loading: false,
        superviseur: superviseurs.data.donnee,
      });
    } catch (error) {
      toast.error("Erreur de chargement des superviseurs");
      set({
        loading: false,
        superviseur: [],
      });
    }
  },
  getAll: async (url) => {
    set({
      loading: true,
      liste: [],
    });
    try {
      const prestataire = await find(url);
      set({
        loading: false,
        liste: prestataire.data,
      });
    } catch (error) {
      set({
        loading: false,
        liste: [],
      });
    }
  },
  getIntentionByInTime: async (url, statut) => {
    set({
      loading: true,
      data: [],
    });
    try {
      const intentions = await find(url);
      set({
        loading: false,
        data: statut === "" ? intentions.data : {
          data: intentions.data.data.filter((e) => e?.inTime === (statut === "true" ? true : false))
        },
      });
    } catch (error) {
      set({
        loading: false,
        data: [],
      });
    }
  },
  generate: async (ticket, avantageNumber) => {
    set({
      codeLoading: true,
      code: null,
    });
    try {
      const code = await generateCode(ticket, avantageNumber);
      set({
        code: code.data,
      });
    } catch (error) {
      set({
        code: null,
        codeLoading: false,
      });
    }
  },
  getData: async (url, param, otherParam) => {
    set({
      loading: true,
      data: [],
    });

    try {
      const getItems = await getAll(url, param, otherParam);
      set({
        loading: false,
        data: getItems.data,
      });
    } catch (error) {
      toast.error(error?.response?.data?.donnee);
      set({
        loading: true,
        data: [],
      });
    }
  },
  getListSouscription: async (url, param, otherParam) => {
    set({
      loading: true,
      listSouscriptions: [],
    });

    try {
      const getItems = await getAll(url, param, otherParam);
      setTimeout(() => {
        set({
          loading: false,
          listSouscriptions: getItems.data,
        });
      }, 900);
    } catch (error) {
      set({
        loading: true,
        listSouscriptions: [],
      });
    }
  },
  getListAbonnement: async (url, param, otherParam) => {
    set({
      loading: true,
      listAbonnement: [],
    });

    try {
      const getItems = await getAll(url, param, otherParam);
      setTimeout(() => {
        set({
          loading: false,
          listAbonnement: getItems.data,
        });
      }, 900);
    } catch (error) {
      set({
        loading: true,
        listAbonnement: [],
      });
    }
  },
}));
